import { image } from "./../../components/assets/assets.jsx";
import { Link } from "react-router-dom";

const UserNav = () => {
  return (
    <div className="leftsidebar leftside-cand">
      <ul className="left-nav left-nav-candidate">
        <li className="job-position-icon">
          <Link to="/user/dashboard">
            <i>
              <img src={image.dashboard} alt="" />
            </i>{" "}
            Home
          </Link>
        </li>
        <li>
          <Link to="/user/profile">
            <i>
              <img src={image.profile} alt="" />
            </i>{" "}
            My Profile
          </Link>
        </li>
        <li className="job-position-icon">
          <Link to="/user/interviews">
            <i>
              <img src={image.interviewer} alt="" />
            </i>{" "}
            My Interviews
          </Link>
        </li>
        <li className="job-position-icon">
          <Link to="/user/notification">
            <i>
              <img src={image.notification} alt="" />
            </i>{" "}
            Alerts
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default UserNav;
